const getSharedDomain = () => {
  const hostname = window.location.hostname;
  return hostname.endsWith('njjamaat.org') ? '.njjamaat.org' : undefined;
};

export function setCookie(name, value, minutes) {
  const expires = new Date();
  expires.setTime(expires.getTime() + minutes * 60 * 1000);
  const domain = getSharedDomain();
  const domainAttr = domain ? `;domain=${domain}` : '';
  const secure = window.location.protocol === 'https:' ? ';Secure' : '';
  document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)};expires=${expires.toUTCString()};path=/${domainAttr};SameSite=Lax${secure}`;
}

export function getCookie(name) {
  const cookieString = document.cookie || '';
  const cookies = cookieString.split('; ').reduce((acc, cookie) => {
    const [cookieName, cookieValue] = cookie.split('=');
    acc[decodeURIComponent(cookieName)] = decodeURIComponent(cookieValue || '');
    return acc;
  }, {});
  return cookies[name] || null;
}

export function deleteCookie(name) {
  const domain = getSharedDomain();
  const domainAttr = domain ? `;domain=${domain}` : '';
  document.cookie = `${encodeURIComponent(name)}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/${domainAttr};SameSite=Lax`;
}
